import { type IAdvancedSelectWidget } from '../IAdvancedSelectWidget.ts';

/**
 * Restituisce le colonne da utilizzare per la tabella nella modale di selezione
 */
export function getAdvancedTableDataColumns(widget: IAdvancedSelectWidget) {
  return widget.selectedLabelFieldColumns &&
    widget.selectedLabelFieldColumns.length > 0
    ? widget.selectedLabelFieldColumns
        .map(colId => widget.columns.find(col => col.id === colId))
        .filter((col): col is NonNullable<typeof col> => col != null)
    : widget.columns;
}
